import React from 'react';
import FormButton from './FormButton';
import styles from './forms.module.css';

export default ({ children, handleSubmit, error, submit, noSubmitButton }) => (
  <form className={styles.form} onSubmit={handleSubmit}>
    <div className={styles.formInner}>
      {children}
    </div>
    {
      !noSubmitButton && (
        <FormButton>
          {submit}
        </FormButton>
      )
    }
  </form>
);
